<script setup lang="ts">
import type { MCardV2Props } from "./MCardV2.props";
import { MCardV2Defaults } from "./MCardV2.props";

import "./MCardV2.scss";
import { randomID } from "../../../utils/helpers";

const props = withDefaults(defineProps<MCardV2Props>(), MCardV2Defaults);
const titleId = randomID("m-card__label");

const isDev =
  typeof import.meta !== "undefined" && (import.meta as any).env && (import.meta as any).env.DEV;
if (isDev && !props.title && !props.ariaLabel) {
  console.warn("m-card-v2: provide title or ariaLabel for accessibility");
}
</script>

<template>
  <div
    class="m-card-v2"
    role="region"
    tabindex="0"
    :aria-label="ariaLabel || undefined"
    :aria-labelledby="!ariaLabel ? titleId : undefined"
  >
    <div class="m-card-v2__header">
      <h2 :id="titleId" class="m-card-v2__title h4-visually">
        <slot name="title">{{ title }}</slot>
      </h2>
    </div>
    <div class="m-card-v2__content" :class="{ content__padding: contentPadding }">
      <slot />
    </div>
  </div>
</template>
